class CropperConvert {
  constructor(scale) {
    this.scale = scale;
  }

  get crop() {
    return new CropperConvert.Crop(this.scale);
  }

  static Crop = class extends CropperConvert {
    to(crop) {
      // from Livelink to Cropper
      const [x, y, width, height] = (crop || []).map(v => v / this.scale);

      return { x, y, width, height };
    }

    from(data) {
      // from Cropper to Livelink
      const { x, y, width, height } = data;

      return [x, y, width, height].map(v => v * this.scale);
    }
  };
};

export default CropperConvert;
